import React from 'react';
import { connect } from 'react-redux';

if (process.env.NODE_ENV !== 'test') {
  require('./StreamingControl.scss');
}

class StreamingControl extends React.Component {
  state = { windowWidth: window.innerWidth };

  toggleStreaming = () => {
    const streamingEnabled =
      (localStorage.getItem('streamingEnabled') || 'true') === 'true';

    localStorage.setItem('streamingEnabled', (!streamingEnabled).toString());
    this.refresh();
  };

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  refresh = () => {
    window.location.reload(true);
  };

  render() {
    const { jaws } = this.props;
    const { windowWidth } = this.state;

    const useWebSockets = jaws.instance ? jaws.instance.useWebSockets : false;

    const isMobile = windowWidth < 767;
    return (
      <div>
        {isMobile && (
          <button
            className="streaming-control"
            onClick={() => this.toggleStreaming()}
          >
            Skru {useWebSockets === true ? 'av' : 'på'} streaming
          </button>
        )}
      </div>
    );
  }
}

function mapStateToProps({ user, jaws }) {
  return { user, jaws };
}

export default connect(mapStateToProps)(StreamingControl);
